import React from 'react';

function Header() {
    return(
        <h2 className='title m-10 justify-center text-center'>getBlockTime</h2>
    );
}

export default Header;